import { useState, useEffect, useRef } from 'react'

export default function FlipDigit({ value }) {
  const [currentValue, setCurrentValue] = useState(value)
  const [beforeValue, setBeforeValue] = useState(value)
  const [isAnimating, setIsAnimating] = useState(false)
  const prevValueRef = useRef(value)

  useEffect(() => {
    if (prevValueRef.current !== value) {
      // 1. Set up the animation states
      setBeforeValue(prevValueRef.current)
      setCurrentValue(value)
      setIsAnimating(true)
      prevValueRef.current = value

      // 2. Clean up animation AND synchronize layers
      const timer = setTimeout(() => {
        setIsAnimating(false)
        setBeforeValue(value) // <-- FIX: Prevents the card from snapping back to the old digit
      }, 500) 

      return () => clearTimeout(timer)
    }
  }, [value])

  return (
    <ul className={`flip ${isAnimating ? 'play' : ''}`}>
      <li className="before">
        <div>
          <div className="up">
            <div className="shadow"></div>
            <div className="inn">{beforeValue}</div>
          </div>
          <div className="down">
            <div className="shadow"></div>
            <div className="inn">{beforeValue}</div>
          </div>
        </div>
      </li>
      <li className="active">
        <div>
          <div className="up">
            <div className="shadow"></div>
            <div className="inn">{currentValue}</div>
          </div>
          <div className="down">
            <div className="shadow"></div>
            <div className="inn">{currentValue}</div>
          </div>
        </div>
      </li>
    </ul>
  )
}